import { OverlayRef } from '@angular/cdk/overlay';

import { PopoverData } from './popover-config';
import { Subscription, takeUntil } from 'rxjs';

export class PopoverOverlayRef<T = any> {
  private subscriptions: Subscription[] = [];

  constructor(
    public overlay: OverlayRef,
    public popoverData: PopoverData<T>,
  ) {
    this.subscriptions.push(
      overlay
        .backdropClick()
        .pipe(takeUntil(this.overlay.detachments()))
        .subscribe(() => this.close()),
    );
  }

  close(): void {
    this.overlay.dispose();
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
